import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import {
    collection,
    getDocs,
    doc,
    setDoc,
    deleteDoc,
    serverTimestamp
} from "firebase/firestore";

import "./css/TripsConfig.css";

export default function TripsConfig({ open, onClose }) {
    const [items, setItems] = useState([]);
    const [editorPicks, setEditorPicks] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [search, setSearch] = useState("");

    useEffect(() => {
        if (!open) return;

        async function loadData() {
            setLoading(true);
            setError(null);

            try {
                const collectionsList = ["trips", "ai_trips", "guides", "places"];
                let combined = [];

                for (const col of collectionsList) {
                    const snap = await getDocs(collection(db, col));

                    snap.forEach((docSnap) => {
                        const data = docSnap.data();

                        combined.push({
                            id: docSnap.id,
                            collection: col,
                            title: data.title || data.name || "Untitled",
                            views: data.views || data.viewsCount || 0,
                            likes: data.likesCount || 0,
                            slug: data.slug || docSnap.id,
                        });
                    });
                }

                // ✅ LOAD EDITOR CHOICE COLLECTION
                const editorSnap = await getDocs(collection(db, "editor_choice"));
                const editorData = [];

                editorSnap.forEach((docSnap) => {
                    const data = docSnap.data();

                    editorData.push({
                        id: data.refId,
                        collection: data.collection,
                    });
                });

                setItems(combined);
                setEditorPicks(editorData);

            } catch (err) {
                console.error(err);
                setError("Failed to load data");
            } finally {
                setLoading(false);
            }
        }

        loadData();
    }, [open]);


    if (!open) return null;

    const toggleEditorsChoice = async (item) => {
        const exists = editorPicks.find(
            (x) => x.id === item.id && x.collection === item.collection
        );

        try {
            if (exists) {
                // 🔥 Remove from Firestore
                await deleteDoc(
                    doc(db, "editor_choice", `${item.collection}_${item.id}`)
                );

                // Remove locally
                setEditorPicks((prev) =>
                    prev.filter(
                        (x) =>
                            !(x.id === item.id && x.collection === item.collection)
                    )
                );
            } else {
                // 🔥 Add to Firestore
                await setDoc(
                    doc(db, "editor_choice", `${item.collection}_${item.id}`),
                    {
                        refId: item.id,
                        collection: item.collection,
                        title: item.title,
                        slug: item.slug,
                        createdAt: serverTimestamp(),
                    }
                );

                // Add locally
                setEditorPicks((prev) => [
                    ...prev,
                    { id: item.id, collection: item.collection },
                ]);
            }
        } catch (err) {
            console.error("Editor choice update failed:", err);
            setError("Failed to update editor choice");
        }
    };


    const handleClose = () => {
        setEditorPicks([]);
        setError(null);
        onClose();
    };

    const filteredItems = items.filter((item) =>
        item.title.toLowerCase().includes(search.toLowerCase()) ||
        item.collection.toLowerCase().includes(search.toLowerCase())
    );

    return (
        <div
            className="modal-backdrop"
            onMouseDown={(e) => e.target === e.currentTarget && handleClose()}
        >
            <div className="modal trips-config-modal">
                <h3>Trips Configuration</h3>
                <div className="tc-search">
                    <input
                        type="text"
                        placeholder="Search trips, guides, places..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                </div>

                {loading && <div className="muted">Loading collections...</div>}
                {error && <div className="error">{error}</div>}

                <div className="tc-scroll">
                    {filteredItems.map((item) => {
                        const isEditorPick = editorPicks.find(
                            (x) =>
                                x.id === item.id &&
                                x.collection === item.collection
                        );

                        return (
                            <div
                                key={`${item.collection}_${item.id}`}
                                className="tc-row"
                            >
                                {/* Left Info */}
                                <div className="tc-left">
                                    <div className="tc-title">{item.title}</div>
                                    <div className="tc-collection">
                                        {item.collection}
                                    </div>
                                </div>

                                {/* Right Actions */}
                                <div className="tc-actions">
                                    <span className="tc-stat">👁 {item.views}</span>
                                    <span className="tc-stat">❤️ {item.likes}</span>

                                    <button
                                        className={`btn btn-small ${isEditorPick ? "btn-primary" : "btn-secondary"
                                            }`}
                                        onClick={() => toggleEditorsChoice(item)}
                                    >
                                        ⭐ Editor’s Choice
                                    </button>

                                    <button
                                        className="btn btn-small btn-secondary"
                                        onClick={() =>
                                            window.open(`/${item.slug}`, "_blank")
                                        }
                                    >
                                        View →
                                    </button>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}
